import React from "react";
import { Provider } from "react-redux";
import { store } from "./src/store/store";

// Import global CSS variables
import "./src/styles/variables.css";

// Wraps every page in a Redux Provider
export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};
